import {
  WITHDRAW_CIRCUIT_WASM,
  WITHDRAW_CIRCUIT_ZKEY,
  resolveBrowserCircuitPaths,
  resolveCircuitPathsFromBase,
  type CircuitPaths,
} from "./constants";

export {
  PACKAGE_NAME,
  SELF_HOSTED_CIRCUIT_BASE,
  WITHDRAW_CIRCUIT_SHA256,
  WITHDRAW_CIRCUIT_WASM,
  WITHDRAW_CIRCUIT_ZKEY,
  resolveBrowserCircuitPaths,
  resolveCircuitPathsFromBase,
  resolveNpmCdnCircuitPaths,
  resolveNpmCdnCircuitBase,
  type CircuitPaths,
} from "./constants";

/**
 * Resolve default Groth16 circuit URLs.
 *
 * Published as `arcane-sdk/circuits/paths` so `import.meta.url` stays next to
 * `withdraw.wasm` and `withdraw.zkey` in `dist/circuits/` (Node / unbundled ESM).
 *
 * In the browser, defaults to `/node_modules/<pkg>/dist/circuits/` on localhost
 * and the pinned, SHA-256-verified jsDelivr CDN in production (domain-independent).
 * Override via {@link ArcaneSdkInitOptions.circuitPathsBase},
 * {@link resolveCircuitPathsFromBase}, or {@link GenerateWithdrawProofOptions}.
 */
export function resolveCircuitPaths(base?: string): CircuitPaths {
  if (base !== undefined) {
    return resolveCircuitPathsFromBase(base);
  }

  const browser = resolveBrowserCircuitPaths();
  if (browser) {
    return browser;
  }

  return {
    wasm: new URL(`./${WITHDRAW_CIRCUIT_WASM}`, import.meta.url).href,
    zkey: new URL(`./${WITHDRAW_CIRCUIT_ZKEY}`, import.meta.url).href,
  };
}
